import store from '@/store';
import LocalStorage from './LocalStorage';


/**
 * 
 * Redirects user to user service onboarding application
 */
export const redirectToOnboarding = () => {
  window.location.href = `${process.env.VUE_APP_EXPORO_USER_URL}/#onboarding?successUrl=${window.location.origin}${window.location.pathname}&type=wphgVermittlungSTO`;
};

/**
 * Show sign in modal 
 * Redirects user to exporo signin application
 */
export const redirectToLogin = () => {
  
  if(!LocalStorage.has('REDIRECT_TO')){
    // means it could be an axios redirect
    LocalStorage.add('REDIRECT_TO', `${window.location.pathname}${window.location.hash}${window.location.search}`);
  }

  window.location.href = `${process.env.VUE_APP_EXPORO_USER_URL}/#/signin?redirectURL=${window.location.origin}${window.location.pathname}`;
  
  // show sign in modal
  store.dispatch('appState/signedOut');
};
/**
 * Show create wallet modal
 * Redirects user to ewallet application
 */
export const createWallet = () => {
  // show create wallet modal
  store.dispatch('appState/createWallet');
};
